export const getVaStore = () => {
  const vaCountryStoreMap = {
    CA: "US",
    MX: "US",
    PR: "US",
    VI: "US",
  };

  const browseCountry = window.asos.webContext.getBrowseCountry();

  if (Object.keys(vaCountryStoreMap).includes(browseCountry)) {
    return vaCountryStoreMap[browseCountry];
  }

  return window.asos.webContext.getStoreId();
};
